export default __webpack_public_path__ + "static/media/scratch9.25bc28fe.mp3";